import { t as o } from "./ZudokuContext-BcqSiygJ.js";
const u = (a = []) => ({
  getRoutes: () => {
    const e = [];
    return o(a, (t) => {
      t.type === "custom-page" && e.push({
        path: t.path,
        element: t.element,
        handle: {
          layout: t.layout ?? "default"
        }
      });
    }), e;
  }
});
export {
  u as customPagesPlugin
};
//# sourceMappingURL=zudoku.plugin-custom-pages.js.map
